<h1 mat-dialog-title i18n>Manual Password Reset <h2>- {{dialogData.user.email}}</h2></h1>

<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div mat-dialog-content class="main-content">
		<div class="row">
			<div class="col-12">
				<mat-form-field appearance="standard" class="w-100">
					<mat-label i18n>Password</mat-label>
					<input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" cdkFocusInitial />
					<mat-hint
						[ngClass]="{ 'text-success': formInputs.get('password').valid }"
						i18n
					>minimum 8, a mix of uppercase, lowercase and number characters</mat-hint>
					<button
						mat-icon-button
						matSuffix
						(click)="hidePassword = !hidePassword"
						i18n-title="show/hide password button"
						title="Show/Hide password"
						type="button"
						tabindex="-1"
					>
						<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
					</button>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.password"
						[type]="formEditorInputType.password"
					></mat-error>
				</mat-form-field>
				<mat-form-field appearance="standard" class="w-100">
					<mat-label
						i18n="confirm password form input|label to describe the confirm password input field"
					>Confirm password</mat-label>
					<input
						matInput
						[type]="hidePassword ? 'password' : 'text'"
						formControlName="password2"
					/>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.password2"
						[type]="formEditorInputType.password"
					></mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>

	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				[disabled]="formInputs.invalid"
				i18n
			>Ok</button>
		</div>
	</div>
</form>
